import logs from "../services/activity.logs";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        errors: null,
        currentPage: 1,
        totalPerPage: 1,
        activityLogs: [],
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
    },
    mutations: {
        setLoading(state, loading) {
            state.loading = loading;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.data.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        setActivityLogs (state, logs) {
            state.activityLogs = logs;
        }
    },
    actions: {
        async getActivityLogs({ commit }, request) {
            commit("setLoading", true);
            try {
                await commit("setActivityLogs", []);
                let response = await logs.getActivityLogs(request.page, request.payload);

                console.log(response.data);
                
                await commit("setActivityLogs", response.data);
                await commit("pagination", response);
                commit("setLoading", false);
            } catch (errors) {
                commit("errors", errors);
            }
        },
    }
};
